import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components';

export enum DcIcons {
	Account = 'account',
	Activate = 'activate',
	CloseModal = 'closeModal',
	Copy = 'copy',
	DataChain = 'data-chain',
	Deactivate = 'deactivate',
	Delete = 'delete',
	DeleteForever = 'delete-forever',
	DcConsoleModule = 'dc-console-module',
	DcCoreModule = 'dc-core-module',
	DcCodeModule = 'dc-code-module',
	DcHandleModule = 'dc-handle-module',
	DcMaestroModule = 'dc-maestro-module',
	DcMarketplaceModule = 'dc-marketplace-module',
	Edit = 'edit',
	GroupsFeature = 'groups-feature',
	Info = 'info',
	LoggerInheritance = 'logger-inheritance',
	Logout = 'logout',
	Link = 'dc-link',
	Menu = 'menu',
	MenuMoreOptionsHandle = 'menu-more-options-open-handle',
	ProductsInstances = 'products-instances',
	Remove = 'remove',
	RoleConsumer = 'role-direct-consumer',
	RoleConsumerInherited = 'role-indirect-consumer',
	RoleMember = 'role-direct-member',
	RoleMemberInherited = 'role-Indirect-member',
	RoleAdminOrg = 'role-direct-admin',
	RoleAdminOrgInherited = 'role-indirect-admin',
	RoleSuperAdmin = 'role-direct-super-admin',
	RoleSuperAdminInherited = 'role-indirect-super-admin',
	RoleCreator = 'role-direct-creator',
	RoleCreatorInherited = 'role-indirect-creator',
	RoleAdminModule = 'role-direct-admin-module',
	RoleAdminModuleInherited = 'role-indirect-admin-module',
	Save = 'save',
	Token = 'token',
	UsersFeature = 'users-feature',
	Update = 'update',
	Version = 'version',
	Warning = 'warning',
}

@Injectable()
export class AppConsoleIcons extends AppIcons {
	private readonly path = './assets/img';
	protected icons: IIcons = {
		[DcIcons.Activate]: `${this.path}/common/flash_on_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Account]: `${this.path}/module/account_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.CloseModal]: `${this.path}/common/close_black_24dp.svg`,
		[DcIcons.Copy]: `${this.path}/common/file_copy_24dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.DataChain]: `${this.path}/common/dataChain.svg`,
		[DcIcons.Deactivate]: `${this.path}/common/flash_off_48dp_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Delete]: `${this.path}/common/delete_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.DeleteForever]: `${this.path}/common/delete_forever_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.DcConsoleModule]: `${this.path}/module/DC-color-solo.svg`,
		[DcIcons.DcCoreModule]: `${this.path}/module/GD-color-solo.svg`,
		[DcIcons.DcCodeModule]: `${this.path}/module/DCC-logo-color.svg`,
		[DcIcons.DcHandleModule]: `${this.path}/module/HD-logo-color.svg`,
		[DcIcons.DcMaestroModule]: `${this.path}/module/DCM-color-solo.svg`,
		[DcIcons.DcMarketplaceModule]: `${this.path}/module/DCMP-color-solo.svg`,
		[DcIcons.Edit]: `${this.path}/common/edit_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
		[DcIcons.GroupsFeature]: `${this.path}/common/groups_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Info]: `${this.path}/common/info_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.LoggerInheritance]: `${this.path}/common/inheritance_propagation_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Logout]: `${this.path}/common/logout_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Link]: `${this.path}/common/link_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Menu]: `${this.path}/common/menu_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.MenuMoreOptionsHandle]: `${this.path}/common/more_vert_FILL0_wght400_GRAD0_opsz24.svg`,
		[DcIcons.ProductsInstances]: `${this.path}/module/select_window_24dp_E8EAED_FILL0_wght100_GRAD0_opsz48.svg`,
		[DcIcons.Remove]: `${this.path}/common/move_item_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleAdminModule]: `${this.path}/common/role_direct_organisation_module_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleAdminModuleInherited]: `${this.path}/common/role_indirect_organisation_module_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleAdminOrg]: `${this.path}/common/role_direct_admin_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleAdminOrgInherited]: `${this.path}/common/role_indirect_admin_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleConsumer]: `${this.path}/common/role_direct_consumer_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleConsumerInherited]: `${this.path}/common/role_indirect_consumer_48dp_5F6368_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleCreator]: `${this.path}/common/role_direct_creator_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleCreatorInherited]: `${this.path}/common/role_indirect_creator_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleMember]: `${this.path}/common/role_direct_member_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleMemberInherited]: `${this.path}/common/role_indirect_member_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleSuperAdmin]: `${this.path}/common/role_direct_super_admin_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.RoleSuperAdminInherited]: `${this.path}/common/role_indirect_super_admin_48dp_000000_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Save]: `${this.path}/common/save_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Token]: `${this.path}/common/key_48dp_FILL0_wght400_GRAD0_opsz48.svg`,
		[DcIcons.Update]: `${this.path}/common/update_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.UsersFeature]: `${this.path}/common/person_FILL1_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Version]: `${this.path}/common/version_48dp_FILL0_wght300_GRAD0_opsz48.svg`,
		[DcIcons.Warning]: `${this.path}/common/warning_48dp_FILL1_wght400_GRAD0_opsz48.svg`,
	};
}
